export default __webpack_public_path__ + "paddle_exploitb6cf70.png";